import React, { useState, useEffect } from 'react';
import Image from '../../../components/atom/image';
import { Link, withRouter } from 'react-router-dom';
import client from '../../../lib/crypto/client'
import TopJson from '../top.json';
import './shared.css';
import { useSelector, useDispatch } from 'react-redux';
import { getCartCount, cvlData, resetGuest, updateGuest } from '../../../redux/actions/trans/authAction';
import loginApi from '../../loginApi';
import ApiCall from '../../trans/trans';
import NFOCountdownTimer from '../../../components/organism/nfoCountdownTimer';
import WhatsappPromoHeader from '../../../components/headerNew/WhatsappHeaderPromo'
import { getDecryptedItem, setEncryptedItem } from '../../../helper/methods';
import NewTextHeader from '../../../components/headerRevamp/NewTextHeader';
import { NFO_DATA } from '../../../helper/constant';
import { useSafeWindow } from '../../../hooks/useSafe';
import { useInitiateHandshake } from '../../../hooks/useInitiateHandshake';
import OldToNewRedirection from '../../../components/molecules/oldToNewRedirection';

let api = new loginApi();
let api2 = new ApiCall();
const Navbar = (props) => {
  const isFromBanner = localStorage.getItem('isFromBanner');
  const [navType, setNavType] = useState('');
  const [topKey, setTopKey] = useState('MF')
  const [PAN, setPAN] = useState('');
  const [ClientType, setClientType] = useState('');
  const [mobileP, setMobileP] = useState(false);
  const dispatch = useDispatch()
  const userInfo = getDecryptedItem("userInfo");
  const safeWindow = useSafeWindow();
  const stateData = useSelector(state => state.Auth);
  const { initiateHandshake } = useInitiateHandshake();

  const mobileProfileClick = (data) => {
    setMobileP(data)
  }

  const navTypeClick = (data) => {
    if (navType === data) {
      setNavType('')
    } else {
      setNavType(data)
    }

  }

  useEffect(() => {
    if(!safeWindow) return;
    const tmpHideSidebar = ["/fab-plan/investment-calculator"]
    if (tmpHideSidebar.includes(safeWindow?.location.pathname)) {
      document.body?.classList?.toggle('sidebar-icon-only')
      if (!document.body?.classList?.contains('sidebar-icon-only')) {
        document.body?.classList?.toggle('sidebar-icon-only')
      }
    }
  }, [safeWindow?.location.pathname])

  const handleClickOnBurgerMenu = () => {
    document.body?.classList?.toggle('sidebar-icon-only')
    props.burgermenu()
  }

  /*
  // old function
  const topHeading = (data) => {
    let { internal, filter, url, baseDomain, route } = data;
    if (PAN !== '') {
      let res = api.encryptSSO("panNo=" + PAN);

      let baseDomainUrl = baseDomain[process.env.REACT_APP_WEBAPP_ENV] || baseDomain["uat"];
      let domainUrl = `${baseDomainUrl}${route}`;

      let lastURL = domainUrl + 'ctx=' + res;
      console.log(lastURL, 'lastURL')
      if(safeWindow) safeWindow.location.href = lastURL;
    }
  }
  */

 const topHeading = (data) => {
    let { internal, filter, url, baseDomain, route } = data;
    if(filter === "MF") {
      return;
    }
    if (PAN !== '') {
      initiateHandshake({ panNo: PAN }, null, filter)
    }
  }


  const handleLogout = () => {
    props.logout();
  }

  const closePOpUp = () => {
    // setHit(hit?false:true)
    let getNavbar = document?.querySelectorAll('.navbarTop .nav-item');
    console.log(getNavbar, 'getNavbar')
    getNavbar?.forEach((curr) => {
      console.log(curr.childNodes, 'Sujeet')
      if (curr.childNodes[1] !== undefined) {
        curr.childNodes[1].classList.remove('show');
      }

      //  let checkClass= curr.getElementByClassName('.show');
      //console.log(checkClass,'checkClass')
    })


  }

  useEffect(() => {
    console.log(props, 'navbarProps')
    document.getElementById('mobileBAR')?.classList?.remove("open");
    try {
      let panNo = stateData['cvlData']['pan'];

      dispatch(getCartCount({
        apiName: "GetCartCount",
        body: {
          arnCode: "",
          panNo: panNo,
        }
      }))
    } catch (error) { }
  }, [props])

  // useEffect(() => {
  //   console.log("calling use effect all the time");
  //   try{
  //     let panNo = stateData['cvlData']['pan'];

  //     dispatch(getCartCount({
  //       apiName: "GetCartCount",
  //       body: {
  //         arnCode: "",
  //         panNo: panNo,
  //       }
  //     }))
  //   }catch(error){}
  // })

  useEffect(() => {

    if (typeof window !== 'undefined') {

      async function setInitials() {
        let clientTypeArr = localStorage.getItem('ClientType');
        let panNoArr = getDecryptedItem("uniqueKey");

        if (!panNoArr || !clientTypeArr) {
          // Call PAN from Token.
          // Call CVL API.
          // Call ClientType API.
          // Set localstorage.
          let CustPAN = "";
          let getPayload = {
            apiName: "GetPanFromToken",
            params: ""
          }
          let apiResponsePAN = await api2.commonGet(getPayload);
          console.log("apiResponsePAN =========", apiResponsePAN);
          if (apiResponsePAN.data?.success === true) {
            CustPAN = apiResponsePAN.data.data;
            let CVLpayload = {
              "apiName": "kycCheck",
              "body": { panNo: CustPAN }
            };
            let kycResponse = await api.common(CVLpayload);

            let payloadClientType = {
              "apiName": "clientType",
              "body": { panNo: CustPAN }
            };
            let clientTypeResponse = await api.common(payloadClientType);

            localStorage.setItem('ClientType', JSON.stringify(clientTypeResponse.data));
            setEncryptedItem("uniqueKey", { panNo: CustPAN, nameAsOnPan: kycResponse.data?.data?.nameAsOnPan });

            let userInfoPresent = getDecryptedItem('userInfo');
            if (userInfoPresent) {
              userInfoPresent = userInfoPresent || {};
              userInfoPresent = {
                ...userInfoPresent,
                paN_NO: CustPAN,
                clientName: kycResponse.data?.data?.nameAsOnPan
              };
              setEncryptedItem('userInfo', userInfoPresent);
            } else {
              let obj = {
                paN_NO: CustPAN,
                clientName: kycResponse.data?.data?.nameAsOnPan
              }
              setEncryptedItem('userInfo', obj);
            }
          }
        }

        // let panNoArr = getDecryptedItem("uniqueKey');
        if (panNoArr) {
          let jsonData = panNoArr;
          setPAN(jsonData.panNo);
        }
        // let clientTypeArr = localStorage.getItem('ClientType');
        if (clientTypeArr) {
          let clientJsonData = JSON.parse(clientTypeArr);
          if (clientJsonData.data.existingClient != "" && clientJsonData.data.existingClient != "BOTH") {
            let prods = clientJsonData.data.existingClient.split(",");
            if (prods.length > 1) {
              setClientType("BOTH");
            }
          } else {
            setClientType(clientJsonData.data.existingClient);
          }
        }
      }
      setInitials();

      var localData = getDecryptedItem("uniqueKey");
      if (localData) {
        var jsonData = localData;
        dispatch(cvlData({
          pan: jsonData.panNo,
          nameAsOnPan: jsonData.nameAsOnPan
        }))
      }
      var guestData = localStorage.getItem('isGuest');
      if (guestData) {
        var guestJsonData = JSON.parse(guestData);
      }
    }

    let getNavbar = document.querySelectorAll('.navbarTop .nav-item');

    const mouseOverListener = (curr, el) => {
      console.log(el.childNodes, 'el.childNodes', curr)
      if (el.childNodes[1] !== undefined) {
        el.childNodes[1].classList.add('show');
        el.classList.add('show');
      }
    }

    const mouseOutListener = (curr, el) => {
      console.log(el.childNodes, 'el.childNodesover', curr)
      if (el.childNodes[1] !== undefined) {
        el.childNodes[1].classList.remove('show');
        el.classList.remove('show');
      }
    }

    const mouseClickListener = (curr, el) => {
      console.log(el.childNodes, 'el.childNodesover', curr)
      if (el.childNodes[1] !== undefined) {
        el.childNodes[1].classList.remove('show');
        el.classList.remove('show');
      }
    }


    getNavbar?.forEach((el) => {
      el.addEventListener('mouseover', (curr) => mouseOverListener(curr, el));
      el.addEventListener('mouseout', (curr) => mouseOutListener(curr, el));
      el.addEventListener('click', (curr) => mouseClickListener(curr, el))
    })

    /* let getNavbar = document.querySelectorAll('.navbarTop .nav-item');
    let panNo1 = document.getElementById("uniqueKey").value;
    setPAN(panNo1);
    let clientType = document.getElementById("clientType").value;
    setClientType(clientType);
    let getNavbar = document.querySelectorAll('.navbarTop .nav-item');
    
    let panNoArr = getDecryptedItem("uniqueKey");
    if (panNoArr) {
        let jsonData = JSON.parse(panNoArr);
        setPAN(jsonData.panNo);
    }
    let clientTypeArr = localStorage.getItem('ClientType');
    if(clientTypeArr){
      let clientJsonData = JSON.parse(clientTypeArr);
      setClientType(clientJsonData.data.existingClient);
    }
    getNavbar.forEach((el) => {
      el.addEventListener('mouseover', function (curr) {
        console.log(el.childNodes, 'el.childNodes', curr)
        if (el.childNodes[1] !== undefined) {
          el.childNodes[1].classList.add('show');
          el.classList.add('show');
        }

      });
      el.addEventListener('mouseout', function (curr) {
        console.log(el.childNodes, 'el.childNodesover', curr)
        if (el.childNodes[1] !== undefined) {
          el.childNodes[1].classList.remove('show');
          el.classList.remove('show');
        }

      });
    }) */

    try {
      let panNo = stateData['cvlData']['pan'];

      dispatch(getCartCount({
        apiName: "GetCartCount",
        body: {
          arnCode: "",
          panNo: panNo,
        }
      }))
    } catch (error) { }

    return (() => {
      if (getNavbar) {
        getNavbar?.forEach?.((el) => {
          el.removeEventListener('mouseover', (curr) => mouseOverListener(curr, el));
          el.removeEventListener('mouseout', (curr) => mouseOutListener(curr, el));
          el.removeEventListener('click', (curr) => mouseClickListener(curr, el));
        })
      }
    });

  }, [])


  const toggleOffcanvas = () => {
    document.querySelector('.sidebar-offcanvas')?.classList?.toggle('active');
    document.querySelector('button.navbar-toggler.navbar-toggler-right')?.classList?.toggle('open');
  }

  const gotoContactUs = () => {

    //props.history.push(`/contact-us`);
    if(safeWindow) safeWindow.location.href = "/mutualfund/contact-us";
    // document.getElementById("myDIV").style.display = "none";
  }


  const gotoResetPasscode = () => {
    let page_url = process.env.REACT_APP_MODE === "development" ? "/login/resetpasscode" : "/mutualfund/login/resetpasscode";
    if(safeWindow) safeWindow.location.href = page_url;
  }

  var customerName = "";
  /* if (typeof window !== 'undefined') {
    console.log('we are running on the client')
    var localData = getDecryptedItem("uniqueKey");        
    if (localData) {
        var jsonData = JSON.parse(localData);
        customerName = jsonData.nameAsOnPan;
    }        
  } */

  if (stateData['cvlData'] !== null) {
    customerName = stateData?.['cvlData']?.['nameAsOnPan'];
  }


  let pendingCount = 0;
  console.log("stateData['cartCountData']", stateData['cartCountData']);
  if (stateData['cartCountData'] !== null && stateData['cartCountData'] !== undefined) {
    if (stateData['cartCountData'].hasOwnProperty('pendingCount')) {
      pendingCount = stateData['cartCountData']['pendingCount'];
    }
  }




  // let ClientType = localStorage.getItem('ClientType');
  // let isBoth = true;
  // if(ClientType !== ''){
  //   let ClientTypeJson = JSON.parse(ClientType);
  //   console.log("ClientTypeJson", ClientTypeJson)
  //   if(ClientTypeJson!==null){    
  //     if(ClientTypeJson.success === true){
  //       if(ClientTypeJson.data.existingClient === "BOTH"){
  //         isBoth = true;
  //       }
  //     }        
  //   }
  // }
  useEffect(() => {
    if (ClientType !== "") {
      if (ClientType == "BOTH") {
        document.body.classList.add('clientType_body');
      }
    }
  }, [ClientType])

  const toogleMobileMenu = () => {
    document.getElementById('myDIV').classList.toggle("mobile_open");

  }

  const fetchUserInfo = async () => {
    try {
        const response = await api.getUsetInfo();      
        const { success, data = {} } = response?.data || {};
        if (success) {
          console.log("UserInfo from API:", data);
          // remove existing key first
          localStorage.removeItem("userInfo");
          setEncryptedItem("userInfo", data);
          dispatch(cvlData({
              pan: data?.paN_NO,
              nameAsOnPan: data?.clientName
          }))
          console.log("After setEncryptedItem, localStorage:", localStorage.getItem("userInfo"));
        } else {
          console.log("API call failed:", response);
        }
      } catch (error) {
        console.error("Error fetching user info:", error);
      }
  }
  
  useEffect(() => {
    fetchUserInfo();
  }, [])

  // console.log(isBoth,'isBoth')


  // let isBoth = false;
  // if(ClientType == "BOTH"){
  //   isBoth = true;  
  // }
  return (
    <React.Fragment>
      <nav className="navbar default-layout-navbar col-lg-12 col-12 p-0 fixed-top d-flex flex-row">

        {/* <WhatsappPromoHeader /> */}
        {
          // ===================================================================
          // NFO CHANGE START (Show NFO Counter or default promo header)
          // ===================================================================
        }
        {/* {isFromBanner ? null : NFO_DATA.NFO_IS_ACTIVE
          ? <NFOCountdownTimer showCounterTimer={props.showCounterTimer} heightForStrip={props.heightForStrip} />
          : <NewTextHeader />
        } */}
        {
          // ===================================================================
          // NFO CHANGE END
          // ===================================================================
        }
        {
          ((ClientType === "BOTH" && !props.activeAdminUser && !isFromBanner)) ?
            <div className="container-scroller">
              <div className="moamc-postmenu-productbox clearfix">
                <div className="headerwp clearfix">
                  <div className="headerpostmenu clearfix">

                    {/* products band desktop*/}
                    <ul className="jeg_menu jeg_top_menu sf-js-enabled sf-arrows headerpostmenu-desktop" style={{ touchAction: 'pan-y' }}>
                      {TopJson.map((curr, index) => {
                        let clientTypeArr2 = localStorage.getItem('ClientType');
                        if (clientTypeArr2) {
                          let clientJsonData = JSON.parse(clientTypeArr2);
                          let prods2 = clientJsonData.data.existingClient;
                          if (prods2.indexOf(curr.filter) != -1) {
                            return (
                              <li id="menu-item-704" key={index} className="menu-item menu-item-type-custom menu-item-object-custom menu-item-704">
                                <Link to="#" className={`${curr.filter === topKey ? "webdomain-active" : ""}`} onClick={() => topHeading(curr)}>{curr.Heading}</Link></li>
                            )
                          }
                        }
                      })}
                    </ul>
                    {/* products band Mob*/}
                    <ul className="headerpostmenu-mob">
                      <li aria-haspopup="true" className="groupwebsitedropdown"><a href="#">MUTAL FUND<i className="fas fa-angle-down"></i></a>
                        <ul className="sub-menu">
                          {TopJson.map((curr, index) => {
                            return (
                              <li id={`menu-item-70${index}`} key={index} className="menu-item menu-item-type-custom menu-item-object-custom menu-item-704"><a onClick={() => topHeading(curr)}>{curr.Heading}</a></li>
                            )
                          })}

                        </ul>
                      </li>
                    </ul>

                  </div>
                </div>
              </div>
            </div>
            : ''
        }
        <div style={{ "clear": "both" }}></div>



        {/* Company Icon Image */}
        <div className="text-center navbar-brand-wrapper nav-logo">
          <a className="navbar-brand brand-logo"
            href={isFromBanner ? undefined : "/mutualfund/portfolio"} // Disable href when isFromBanner is true
            onClick={(e) => {
              if (isFromBanner) {
                e.preventDefault(); // Prevent navigation
              }
            }}>
            <Image image="nav/mo_logo.png" alt="logo" style={{ marginTop: '8px' }} />
          </a>

          <a className="navbar-brand brand-logo-mini"
            href={isFromBanner ? undefined : "/mutualfund/portfolio"} // Disable href when isFromBanner is true
            onClick={(e) => {
              if (isFromBanner) {
                e.preventDefault(); // Prevent navigation
              }
            }}>
            <Image image="nav/mf-m-min-logo.svg" alt="logo" />
          </a>
        </div>

        <div className="navbar-menu-wrapper d-flex align-items-stretch">

          {/* Desktop Back arrow */}
          {/* <button className={`navbar-toggler align-self-center ${props.isFabConf ? "d-none" : ""}`}
            type="button" data-toggle="minimize"
            onClick={handleClickOnBurgerMenu}
          >
            <span className="mdi mdi-menu"></span>
          </button> */}

          <ul className="navbar-nav navbar-nav-right navbarTop">

            {/* Cart icon disabled */}
            {/* {props.isAdmin || userInfo?.isIndividualPan
              ?
              <li className="nav-item">
                <Link to="/Cart" className="nav-link count-indicator" id="cartDropdown">
                  <Image image="nav/cart.svg" class="nav-link count-indicator" alt="cart-icon" />
                  <span className="badge badge-up badge-pill">{pendingCount}</span>
                </Link>
              </li>
              : null
            } */}

            <li className="nav-item nav-profile dropdown mobile_hover" >
              <a className="nav-link dropdown-toggle" id="profileDropdown" href="#" onClick={toogleMobileMenu} data-toggle="dropdown" aria-expanded="false">
                <div className="nav-profile-img">
                  <Image image="nav/profile-icon.png" class="mobileProfile" alt="image" />
                </div>
                <div className="nav-profile-text">
                  <p className="username-navbar">{!props.activeAdminUser ? customerName : ""}</p>
                </div>
              </a>
              <div className="dropdown-menu navbar-dropdown mobile_open dropdown-menu-right p-0 border-0 font-size-sm" id="myDIV" data-x-placement="bottom-end">

                <div className="p-2">
                  {/* <h5 onClick={closePOpUp} className="dropdown-header text-uppercase pl-2 text-dark">User Options</h5>

                  <a className="dropdown-item py-1 d-flex align-items-center justify-content-between user-options-menu" onClick={gotoContactUs}>
                    <span>Contact Us</span>
                    <span className="p-0">
                    </span>
                  </a>
                  <a onClick={closePOpUp} className="dropdown-item py-1 d-flex align-items-center justify-content-between user-options-menu" href="/mutualfund/profile">
                    <span>Profile</span>
                    <span className="p-0">
                      <i className="mdi mdi-account-outline ml-1"></i>
                    </span>
                  </a>
                  <a onClick={gotoResetPasscode}
                    className="dropdown-item py-1 d-flex align-items-center justify-content-between user-options-menu"
                  >
                    <span>Reset Passcode</span>
                    <span className="p-0">
                      <i className="mdi mdi-lock-reset ml-1"></i>
                    </span>
                  </a>

                  <a onClick={closePOpUp} className="dropdown-item py-1 d-flex align-items-center justify-content-between user-options-menu" href="/mutualfund/otp-preference">
                    <span>OTP Preference</span>
                    <span className="p-0">
                      <Image image="nav/otpPreference.svg" class="otpPreference" alt="image" />
                    </span>
                  </a>
                  <div role="separator" className="dropdown-divider"></div> */}
                  <h5 className="dropdown-header text-uppercase  pl-2 text-dark mt-2">Actions</h5>

                  <a className="dropdown-item py-1 d-flex align-items-center justify-content-between" onClick={handleLogout}>
                    <span>Log Out</span>
                    <i className="mdi mdi-logout ml-1"></i>
                  </a>
                </div>
              </div>
            </li>

          </ul>

          {/* Hamburger Menu Icon */}
          <button className={`navbar-toggler navbar-toggler-right d-lg-none align-self-center ${props.isFabConf ? "d-none" : ""}`} type="button" data-toggle="offcanvas" onClick={() => toggleOffcanvas()} id="mobileBAR">
            {/* <span className="mdi mdi-menu"></span> */}
            <Image image="nav/menu.png" class="mobileProfile" alt="image" />
          </button>
        </div>

        <OldToNewRedirection />
      </nav>
    </React.Fragment>
  )
}


export default withRouter(Navbar)